import { useMutation } from "@tanstack/react-query";
import { downloadPerAssetPdf } from "../api/exports";

/**
 * Phase 7 Plan 03 / D-150 + D-164 — Per-asset history PDF export mutation hook.
 *
 * Wraps downloadPerAssetPdf in a TanStack Query useMutation so the AssetSidePanel
 * Export-history button can drive isPending + onError surfaces from the existing
 * mutation infrastructure (mirrors useResetPin.ts shape — no cache invalidation
 * because the server endpoint is read-only and emits a binary stream).
 *
 * Errors are surfaced via the standard mutation onError flow; the side-panel
 * does not block other actions on failure.
 */
export function useExportPerAssetHistoryPdf() {
  return useMutation<void, Error, { assetId: number }>({
    mutationFn: ({ assetId }) => downloadPerAssetPdf(assetId),
  });
}
